(function () {
    var OnGogingCtrl = (function () {
        function OnGogingCtrl() {
            this.init.apply(this, arguments);
        }

        OnGogingCtrl.prototype = {
            init: function ($scope, $state, $stateParams, MKioskService, $message) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.MKioskService = MKioskService;
                this.$message = $message;

                this.loadData().then(angular.bind(this, function (list) {
                    this.list = [];

                    // NF-960: Returning dto sample 
                    // {
                    //     "0": {
                    //         "Date": "2024-05-06T00:00:00.000Z",
                    //         "StartDateTime": "2024-05-05 19:44",
                    //         "EndDateTime": "2024-05-06 07:25",
                    //         "Description": "2024-05-05 19:44 - 2024-05-06 07:25",
                    //         "Quantity": 59.795,
                    //         "EstimatedCost": 17.94
                    //     }
                    // }

                    for(var d of list) {
                        let charge = {
                            Quantity: d.Quantity,
                            EstimatedCost: d.EstimatedCost
                        }
                        
                        if (d.StartDateTime) {
                            if (moment(d.StartDateTime, 'YYYY-MM-DD HH:mm').isValid()) {
                                charge.StartDateTime = moment(d.StartDateTime, 'YYYY-MM-DD HH:mm').toDate();
                            }
                        }

                        if (d.EndDateTime) {
                            if (moment(d.EndDateTime, 'YYYY-MM-DD HH:mm').isValid()) {
                                charge.EndDateTime = moment(d.EndDateTime, 'YYYY-MM-DD HH:mm').toDate();
                            }
                        }

                        this.list.push(charge);
                    }
                }), this.$message.error);
            },

            back: function () {

                if (this.$stateParams && this.$stateParams.prev) {
                    this.$state.go(this.$stateParams.prev);
                } else {
                    this.$state.go("internal.homecharges");
                }                
            },
            loadData: function () {
                return this.MKioskService.getDetailOfOngoingPeriod();
            }            
        };
        OnGogingCtrl.$inject = ['$scope', '$state', '$stateParams', 'MKioskService', '$message'];
        return OnGogingCtrl;
    }());
    angular.module('internal.homecharges').controller('OnGogingCtrl', OnGogingCtrl)
})();


